// extracted by mini-css-extract-plugin
module.exports = {"main":"AboutPage_main__1Oj8W","heading":"AboutPage_heading__3zJV-","finance":"AboutPage_finance__23JBQ","serviceList":"AboutPage_serviceList__1UVqG"};